import { render } from "./YourDetailsNQY.vue?vue&type=template&id=5a957b18&scoped=true"
import script from "./YourDetailsNQY.vue?vue&type=script&lang=js"
export * from "./YourDetailsNQY.vue?vue&type=script&lang=js"

import "./YourDetailsNQY.vue?vue&type=style&index=0&id=5a957b18&lang=scss"
import "./YourDetailsNQY.vue?vue&type=style&index=1&id=5a957b18&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a957b18"]])

export default __exports__